import * as appointment from '../services/ClinicAppointments/ClinicAppointmentService'
import * as clinic from '../services/ClinicAppointments/Clinic_Setup/ClinicDashboard_01Service'
import types from './types'
import debounce from 'lodash.debounce'

export const A_FetchClinicTreatmentList = clinicID => dispatch =>
  appointment
    .fetchClinicTreatmentList(clinicID)
    .then(response => {
      dispatch({ type: types.FETCH_TREATMENT_LIST.OK, list: response })
      return response
    })
    .catch(error => {
      dispatch({ type: types.FETCH_TREATMENT_LIST.FAIL, error })
      return Promise.reject(error)
    })

export const A_FetchTreatmentTypeList = (
  clinic,
  consultationType,
) => dispatch =>
  appointment
    .fetchTreatmentTypeList(clinic, consultationType)
    .then(response => {
      dispatch({ type: types.FETCH_TREATMENT_TYPE_LIST.OK, list: response })
      return response
    })
    .catch(error => {
      dispatch({ type: types.FETCH_TREATMENT_TYPE_LIST.FAIL, error })
      return Promise.reject(error)
    })

const debounceSearchPatients = debounce(
  (dispatch, data) =>
    appointment
      .getFilteredPatientsList(data)
      .then(response => {
        dispatch({ type: types.GET_FILTERED_PATIENTS_LIST.OK, data: response })
      })
      .catch(error => {
        dispatch({ type: types.GET_FILTERED_PATIENTS_LIST.FAIL, error })
      }),
  300,
)

export const A_GetFilteredPatientsList = data => dispatch => {
  dispatch({ type: types.GET_FILTERED_PATIENTS_LIST.REQ, data })
  debounceSearchPatients(dispatch, data)
}

export const A_GetBasicDetails = id => dispatch =>
  clinic
    .getclinicDetails(id)
    .then(response => {
      dispatch({ type: types.GET_BASIC_DETAILS.OK, data: response })
      dispatch({ type: types.VIEWING_CLINIC, clinic: response.id })
      return response
    })
    .catch(error => {
      dispatch({ type: types.GET_BASIC_DETAILS.FAIL, error })
      return Promise.reject(error)
    })
